import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { PATH_DELIMITER, SYSTEM_UNIVERSITY_PATH } from '../../../constant/Constant';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const ACTION_UNIVERSITY_SEARCH = SYSTEM_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_UNIVERSITY_SEARCH';
const ACTION_UNIVERSITY_ADD = SYSTEM_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_NIVERSITY_ADD';
const ACTION_UNIVERSITY_EDIT = SYSTEM_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_UNIVERSITY_EDIT';
const ACTION_UNIVERSITY_REMOVE = SYSTEM_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_UNIVERSITY_REMOVE';
const ACTION_UNIVERSITY_DATA_SEARCH = SYSTEM_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_UNIVERSITY_DATA_SEARCH';

export const actionUniversitySearch = createAction(ACTION_UNIVERSITY_SEARCH);
export const actionUniversityAdd = createAction(ACTION_UNIVERSITY_ADD);
export const actionUniversityEdit = createAction(ACTION_UNIVERSITY_EDIT);
export const actionUniversityRemove = createAction(ACTION_UNIVERSITY_REMOVE);
export const actionUniversityDataSearch = createAction(ACTION_UNIVERSITY_DATA_SEARCH);

export function* systemUniversitySagas() {
    yield takeEvery(ACTION_UNIVERSITY_SEARCH, actionUniversitySearchSaga);
    yield takeEvery(ACTION_UNIVERSITY_ADD, actionUniversityAddSaga);
    yield takeEvery(ACTION_UNIVERSITY_EDIT, actionUniversityEditSaga);
    yield takeEvery(ACTION_UNIVERSITY_REMOVE, actionUniversityRemoveSaga);
    yield takeEvery(ACTION_UNIVERSITY_DATA_SEARCH, actionUniversityDataSearchSaga);
}

function* actionUniversitySearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/university',
        params,
        callback,
    });
    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionUniversityAddSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'post',
        url: `/api/university/${data.universityCd}`,
        data,
        callback,
    });
}

function* actionUniversityEditSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/university/${data.universityCd}`,
        data,
        callback,
    });
}

function* actionUniversityRemoveSaga({ payload: { universityCd, callback } }) {
    yield call(request, {
        method: 'delete',
        url: `/api/university/${universityCd}`,
        callback,
    });
}

function* actionUniversityDataSearchSaga({ payload: { universityCd, callback } }) {
    yield call(request, {
        method: 'get',
        url: `/api/university/${universityCd}`,
        callback,
    });
}
